export { IconFreelancer } from './IconFreelancer';
export { IconMoneyBack } from './IconMoneyBack';
export { IconPiggyBank } from './IconPiggyBank';
export { IconStar } from './IconStar';
export { IconSupport } from './IconSupport';
export { IconTailored } from './IconTailored';
